import { IdAssetBundleThemedEvent } from "../../assetBundles/outskirts/IdAssetBundleThemedEvent";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdBigCharacter } from "../generic/big-character/IdBigCharacter";
import { IdIcon } from "../generic/icon/IdIcon";
import { IdThemedEvent } from "./IdThemedEvent";
export var mapThemedEventInfo = new Map([
    [
        IdThemedEvent.Generic,
        {
            category: IdLoca.empty,
            character: IdBigCharacter.Empty,
            completedDescription: IdLoca.empty,
            description: IdLoca.empty,
            icon: IdIcon.Empty,
            id: IdThemedEvent.Generic,
            name: IdAssetBundleThemedEvent.Generic,
            taskIcons: [
                IdIcon.Empty,
                IdIcon.Empty,
                IdIcon.Empty,
                IdIcon.Empty,
                IdIcon.Empty,
                IdIcon.Empty,
            ],
            title: IdLoca.empty,
        },
    ],
    [
        IdThemedEvent.FairyTale,
        {
            category: IdLoca.event_fairytale_category1,
            character: IdBigCharacter.BigCharacter_Fairytale,
            completedDescription: IdLoca.eventCompleted_fairytale_desc,
            description: IdLoca.event_fairytale_desc,
            icon: IdIcon.FairytaleIcn,
            id: IdThemedEvent.FairyTale,
            name: IdAssetBundleThemedEvent.Fairytale,
            taskIcons: [
                IdIcon.FairytaleThemedEventTask_1_Icn,
                IdIcon.FairytaleThemedEventTask_2_Icn,
                IdIcon.FairytaleThemedEventTask_3_Icn,
                IdIcon.FairytaleThemedEventTask_4_Icn,
                IdIcon.FairytaleThemedEventTask_5_Icn,
                IdIcon.FairytaleThemedEventTask_6_Icn,
            ],
            title: IdLoca.event_fairytale_title,
        },
    ],
    [
        IdThemedEvent.Hawaii,
        {
            category: IdLoca.event_hawaii_category1,
            character: IdBigCharacter.BigCharacter_Hawaii,
            completedDescription: IdLoca.eventCompleted_hawaii_desc,
            description: IdLoca.event_hawaii_desc,
            icon: IdIcon.HawaiiIcn,
            id: IdThemedEvent.Hawaii,
            name: IdAssetBundleThemedEvent.Hawaii,
            taskIcons: [
                IdIcon.HawaiiThemedEventTask_1_Icn,
                IdIcon.HawaiiThemedEventTask_2_Icn,
                IdIcon.HawaiiThemedEventTask_3_Icn,
                IdIcon.HawaiiThemedEventTask_4_Icn,
                IdIcon.HawaiiThemedEventTask_5_Icn,
                IdIcon.HawaiiThemedEventTask_6_Icn,
            ],
            title: IdLoca.event_hawaii_title,
        },
    ],
    [
        IdThemedEvent.Asian,
        {
            category: IdLoca.event_asian_category1,
            character: IdBigCharacter.BigCharacter_Asian,
            completedDescription: IdLoca.eventCompleted_asian_desc,
            description: IdLoca.event_asian_desc,
            icon: IdIcon.AsianIcn,
            id: IdThemedEvent.Asian,
            name: IdAssetBundleThemedEvent.Asian,
            taskIcons: [
                IdIcon.AsianThemedEventTask_1_Icn,
                IdIcon.AsianThemedEventTask_2_Icn,
                IdIcon.AsianThemedEventTask_3_Icn,
                IdIcon.AsianThemedEventTask_4_Icn,
                IdIcon.AsianThemedEventTask_5_Icn,
                IdIcon.AsianThemedEventTask_6_Icn,
            ],
            title: IdLoca.event_asian_title,
        },
    ],
    [
        IdThemedEvent.Camping,
        {
            category: IdLoca.event_camping_category1,
            character: IdBigCharacter.BigCharacter_Camping,
            completedDescription: IdLoca.eventCompleted_camping_desc,
            description: IdLoca.event_camping_desc,
            icon: IdIcon.CampingIcn,
            id: IdThemedEvent.Camping,
            name: IdAssetBundleThemedEvent.Camping,
            taskIcons: [
                IdIcon.CampingThemedEventTask_1_Icn,
                IdIcon.CampingThemedEventTask_2_Icn,
                IdIcon.CampingThemedEventTask_3_Icn,
                IdIcon.CampingThemedEventTask_4_Icn,
                IdIcon.CampingThemedEventTask_5_Icn,
                IdIcon.CampingThemedEventTask_6_Icn,
            ],
            title: IdLoca.event_camping_title,
        },
    ],
    [
        IdThemedEvent.Ufo,
        {
            category: IdLoca.event_ufo_category1,
            character: IdBigCharacter.BigCharacter_Ufo,
            completedDescription: IdLoca.eventCompleted_ufo_desc,
            description: IdLoca.event_ufo_desc,
            icon: IdIcon.UfoIcn,
            id: IdThemedEvent.Ufo,
            name: IdAssetBundleThemedEvent.Ufo,
            taskIcons: [
                IdIcon.UfoThemedEventTask_1_Icn,
                IdIcon.UfoThemedEventTask_2_Icn,
                IdIcon.UfoThemedEventTask_3_Icn,
                IdIcon.UfoThemedEventTask_4_Icn,
                IdIcon.UfoThemedEventTask_5_Icn,
                IdIcon.UfoThemedEventTask_6_Icn,
            ],
            title: IdLoca.event_ufo_title,
        },
    ],
    [
        IdThemedEvent.FoodTruck,
        {
            category: IdLoca.event_foodTruck_category1,
            character: IdBigCharacter.BigCharacter_FoodTruck,
            completedDescription: IdLoca.eventCompleted_foodTruck_desc,
            description: IdLoca.event_foodTruck_desc,
            icon: IdIcon.FoodTruckIcn,
            id: IdThemedEvent.FoodTruck,
            name: IdAssetBundleThemedEvent.FoodTruck,
            taskIcons: [
                IdIcon.FoodTruckThemedEventTask_1_Icn,
                IdIcon.FoodTruckThemedEventTask_2_Icn,
                IdIcon.FoodTruckThemedEventTask_3_Icn,
                IdIcon.FoodTruckThemedEventTask_4_Icn,
                IdIcon.FoodTruckThemedEventTask_5_Icn,
                IdIcon.FoodTruckThemedEventTask_6_Icn,
            ],
            title: IdLoca.event_foodTruck_title,
        },
    ],
    [
        IdThemedEvent.FarmCup,
        {
            category: IdLoca.event_farmCup_category1,
            character: IdBigCharacter.BigCharacter_FarmCup,
            completedDescription: IdLoca.eventCompleted_farmCup_desc,
            description: IdLoca.event_farmCup_desc,
            icon: IdIcon.FarmCupIcn,
            id: IdThemedEvent.FarmCup,
            name: IdAssetBundleThemedEvent.FarmCup,
            taskIcons: [
                IdIcon.FarmCupThemedEventTask_1_Icn,
                IdIcon.FarmCupThemedEventTask_2_Icn,
                IdIcon.FarmCupThemedEventTask_3_Icn,
                IdIcon.FarmCupThemedEventTask_4_Icn,
                IdIcon.FarmCupThemedEventTask_5_Icn,
                IdIcon.FarmCupThemedEventTask_6_Icn,
            ],
            title: IdLoca.event_farmCup_title,
        },
    ],
    [
        IdThemedEvent.Halloween,
        {
            category: IdLoca.event_halloween_category1,
            character: IdBigCharacter.BigCharacter_Halloween,
            completedDescription: IdLoca.eventCompleted_halloween_desc,
            description: IdLoca.event_halloween_desc,
            icon: IdIcon.HalloweenIcn,
            id: IdThemedEvent.Halloween,
            name: IdAssetBundleThemedEvent.Halloween,
            taskIcons: [
                IdIcon.HalloweenThemedEventTask_1_Icn,
                IdIcon.HalloweenThemedEventTask_2_Icn,
                IdIcon.HalloweenThemedEventTask_3_Icn,
                IdIcon.HalloweenThemedEventTask_4_Icn,
                IdIcon.HalloweenThemedEventTask_5_Icn,
                IdIcon.HalloweenThemedEventTask_6_Icn,
            ],
            title: IdLoca.event_halloween_title,
        },
    ],
    [
        IdThemedEvent.Christmas,
        {
            category: IdLoca.event_christmas_category1,
            character: IdBigCharacter.BigCharacter_Christmas,
            completedDescription: IdLoca.eventCompleted_christmas_desc,
            description: IdLoca.event_christmas_desc,
            icon: IdIcon.ChristmasIcn,
            id: IdThemedEvent.Christmas,
            name: IdAssetBundleThemedEvent.Christmas,
            taskIcons: [
                IdIcon.ChristmasThemedEventTask_1_Icn,
                IdIcon.ChristmasThemedEventTask_2_Icn,
                IdIcon.ChristmasThemedEventTask_3_Icn,
                IdIcon.ChristmasThemedEventTask_4_Icn,
                IdIcon.ChristmasThemedEventTask_5_Icn,
                IdIcon.ChristmasThemedEventTask_6_Icn,
            ],
            title: IdLoca.event_christmas_title,
        },
    ],
    [
        IdThemedEvent.Easter,
        {
            category: IdLoca.event_easter_category1,
            character: IdBigCharacter.BigCharacter_Easter,
            completedDescription: IdLoca.eventCompleted_easter_desc,
            description: IdLoca.event_easter_desc,
            icon: IdIcon.EasterIcn,
            id: IdThemedEvent.Easter,
            name: IdAssetBundleThemedEvent.Easter,
            taskIcons: [
                IdIcon.EasterThemedEventTask_1_Icn,
                IdIcon.EasterThemedEventTask_2_Icn,
                IdIcon.EasterThemedEventTask_3_Icn,
                IdIcon.EasterThemedEventTask_4_Icn,
                IdIcon.EasterThemedEventTask_5_Icn,
                IdIcon.EasterThemedEventTask_6_Icn,
            ],
            title: IdLoca.event_easter_title,
        },
    ],
    [
        IdThemedEvent.Wedding,
        {
            category: IdLoca.event_wedding_category1,
            character: IdBigCharacter.BigCharacter_LillyWedding,
            completedDescription: IdLoca.eventCompleted_wedding_desc,
            description: IdLoca.event_wedding_desc,
            icon: IdIcon.WeddingIcn,
            id: IdThemedEvent.Wedding,
            name: IdAssetBundleThemedEvent.Wedding,
            taskIcons: [
                IdIcon.WeddingThemedEventTask_1_Icn,
                IdIcon.WeddingThemedEventTask_2_Icn,
                IdIcon.WeddingThemedEventTask_3_Icn,
                IdIcon.WeddingThemedEventTask_4_Icn,
                IdIcon.WeddingThemedEventTask_5_Icn,
                IdIcon.WeddingThemedEventTask_6_Icn,
            ],
            title: IdLoca.event_wedding_title,
        },
    ],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/mapThemedEventInfo.ts
// module id = 731
// module chunks = 3